import React from "react";
import {
  Grid,
  Card,
  Typography,
  Chip,
  Button,
  Box,
} from "@mui/material";
import { Link } from "react-router-dom";
import GavelRoundedIcon from "@mui/icons-material/GavelRounded";

const pageCardSx = {
  borderRadius: "18px",
  border: "1px solid rgba(47,99,173,0.08)",
  boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
  backgroundColor: "rgba(255,255,255,0.96)",
};

const secondaryButtonSx = {
  borderRadius: "10px",
  textTransform: "none",
  fontWeight: 600,
  px: 2,
  borderColor: "rgba(47,99,173,0.18)",
  color: "#223142",
  whiteSpace: "nowrap",
  "&:hover": {
    borderColor: "#2f63ad",
    color: "#2f63ad",
    backgroundColor: "rgba(47,99,173,0.04)",
  },
};

const ViolationCards = ({
  violations = [],
  violationTypes = [],
  statuses = [],
  getStatusDetails,
}) => {
  const formatDate = (dateStr) =>
    dateStr ? String(dateStr).slice(0, 10) : "N/A";

  const getViolationType = (typeId) =>
    violationTypes.find((t) => String(t.id) === String(typeId));

  const resolveColor = (theme, color) =>
    color && color in theme.palette ? theme.palette[color].main : color || "#2f63ad";

  if (!Array.isArray(violations)) return null;

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={3} alignItems="stretch">
        {violations.map((violation) => {
          const { color, Icon, label } = getStatusDetails(
            violation.status || "",
            statuses
          );

          const violationType = getViolationType(violation.ccr_violation_type_id);

          return (
            <Grid item xs={12} sm={6} md={4} key={violation.id}>
              <Card
                sx={{
                  ...pageCardSx,
                  overflow: "hidden",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Box
                  sx={{
                    height: 5,
                    backgroundColor: (theme) => resolveColor(theme, color),
                  }}
                />

                <Box
                  sx={{
                    p: 2.25,
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "space-between",
                      gap: 1.5,
                      mb: 2,
                    }}
                  >
                    <Box sx={{ minWidth: 0 }}>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
                        <GavelRoundedIcon sx={{ color: "#2f63ad", fontSize: 20 }} />
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 700,
                            color: "#223142",
                            lineHeight: 1.2,
                          }}
                          noWrap
                        >
                          VLT-{violation.id}
                        </Typography>
                      </Box>

                      <Typography
                        variant="body2"
                        sx={{
                          color: "#6b778c",
                          fontWeight: 500,
                        }}
                        noWrap
                      >
                        Property ID: {violation.property_id || "N/A"}
                      </Typography>
                    </Box>

                    <Chip
                      icon={
                        Icon ? (
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Icon sx={{ color: "#fff", fontSize: 18 }} />
                          </Box>
                        ) : undefined
                      }
                      label={(label || "Unknown").toUpperCase()}
                      size="small"
                      sx={{
                        fontWeight: 700,
                        color: "#fff",
                        borderRadius: "999px",
                        backgroundColor: (theme) => resolveColor(theme, color),
                        "& .MuiChip-icon": {
                          color: "#fff",
                        },
                      }}
                    />
                  </Box>

                  <Box sx={{ flexGrow: 1 }}>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#223142",
                        fontWeight: 700,
                        mb: 0.5,
                        lineHeight: 1.35,
                      }}
                    >
                      {violationType?.name || "Unknown Type"}
                    </Typography>

                    {violationType?.rule && (
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#6b778c",
                          mb: 1.25,
                          lineHeight: 1.55,
                          minHeight: 40,
                        }}
                      >
                        {violationType.rule}
                      </Typography>
                    )}

                    <Typography
                      variant="body2"
                      sx={{
                        color: "#6b778c",
                        mb: 2,
                      }}
                    >
                      Violated: {formatDate(violation.violated_at)}
                    </Typography>
                  </Box>

                  <Box sx={{ mt: "auto" }}>
                    <Button
                      component={Link}
                      to={`${violation.id}`}
                      variant="outlined"
                      size="small"
                      sx={secondaryButtonSx}
                    >
                      View Details
                    </Button>
                  </Box>
                </Box>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default ViolationCards;